import { useEffect, useState } from "react";
import { api, euro } from "../api";
import { useAuth } from "../AuthContext";

export default function Settings() {
  const { user } = useAuth();
  const [rates, setRates] = useState(null);
  const [labels, setLabels] = useState({});
  const [codes, setCodes] = useState([]);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    api.get("/settings/rates").then((r) => {
      setRates(r.data.rates); setLabels(r.data.labels); setCodes(r.data.codes);
    });
  }, []);

  const isAdmin = user?.role === "admin";

  async function save() {
    setMsg("");
    try {
      const { data } = await api.put("/settings/rates", { rates });
      setRates(data.rates);
      setMsg("✅ Rates saved");
    } catch (e) {
      setMsg(`❌ ${e?.response?.data?.detail || "Save failed"}`);
    }
  }

  if (!rates) return <div className="text-slate-500">Loading…</div>;

  return (
    <div data-testid="settings-page">
      <h2 className="text-xl font-bold mb-4" style={{ color: "#1a3666" }}>Settings — Role Rates</h2>
      <p className="text-sm text-slate-500 mb-5">Monthly revenue per role (flat, not scaled by utilization). Only admins can edit.</p>

      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden max-w-2xl">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 text-[11px] uppercase">
            <tr>
              <th className="px-3 py-2 text-left">Role</th>
              <th className="px-3 py-2 text-left">Label</th>
              <th className="px-3 py-2 text-right">Monthly Rate (€)</th>
            </tr>
          </thead>
          <tbody>
            {codes.map((c) => (
              <tr key={c} className="border-t border-slate-100" data-testid={`rate-row-${c}`}>
                <td className="px-3 py-2 font-medium">{c}</td>
                <td className="px-3 py-2 text-slate-600 text-xs">{labels[c]}</td>
                <td className="px-3 py-2 text-right">
                  {isAdmin ? (
                    <input type="number" min={0} step={1} value={rates[c] ?? 0}
                           data-testid={`rate-input-${c}`}
                           onChange={(e) => setRates((r) => ({ ...r, [c]: Number(e.target.value) }))}
                           className="w-32 px-2 py-1 border rounded text-right text-sm" />
                  ) : (
                    <span>{euro(rates[c] ?? 0)}</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {isAdmin && (
        <div className="mt-4 flex items-center gap-3">
          <button onClick={save} data-testid="save-rates"
                  className="px-4 py-2 rounded-md text-white text-sm font-semibold"
                  style={{ background: "#1a3666" }}>Save Rates</button>
          {msg && <span className="text-sm">{msg}</span>}
        </div>
      )}
    </div>
  );
}
